module.exports = __webpack_public_path__ + "img/banner15.7d24671c.png";